import { RemixiconComponentType } from '@remixicon/react';

export const RelativeNumberIcon: RemixiconComponentType = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <path d="M7.25 10.5c-.9 0-1.667-.317-2.3-.95A3.133 3.133 0 0 1 4 7.25c0-.9.317-1.667.95-2.3.633-.633 1.4-.95 2.3-.95.9 0 1.667.317 2.3.95.633.633.95 1.4.95 2.3 0 .9-.317 1.667-.95 2.3-.633.633-1.4.95-2.3.95Zm0-1.5c.483 0 .896-.17 1.238-.512C8.829 8.146 9 7.733 9 7.25s-.17-.896-.512-1.237A1.686 1.686 0 0 0 7.25 5.5c-.483 0-.896.17-1.237.513A1.686 1.686 0 0 0 5.5 7.25c0 .483.17.896.513 1.238.341.341.754.512 1.237.512Zm9.5 11c-.9 0-1.667-.317-2.3-.95a3.133 3.133 0 0 1-.95-2.3c0-.9.317-1.667.95-2.3.633-.633 1.4-.95 2.3-.95.9 0 1.667.317 2.3.95.633.633.95 1.4.95 2.3 0 .9-.317 1.667-.95 2.3-.633.633-1.4.95-2.3.95Zm0-1.5c.483 0 .896-.17 1.238-.512.341-.342.512-.755.512-1.238s-.17-.896-.512-1.238A1.686 1.686 0 0 0 16.75 15c-.483 0-.896.17-1.238.512A1.686 1.686 0 0 0 15 16.75c0 .483.17.896.512 1.238a1.69 1.69 0 0 0 1.238.512ZM5.05 20 4 18.95 18.95 4 20 5.05 5.05 20Z" />
  </svg>
);
